import { G } from '@mobily/ts-belt';

import { GetB2bContractsOneResponse } from '@Common/types/bo/b2b/contracts';

type UnusedVacationDays = GetB2bContractsOneResponse['unused_vacation_days'];

export function hasAnyUnusedVacationDaysField(unusedVacationDays: UnusedVacationDays | undefined) {
  const { agreement_starting_date, agreement_end_date, increment_step } = unusedVacationDays ?? {};
  return [agreement_starting_date, agreement_end_date, increment_step].some(G.isNotNullable);
}
